<template>
    <div class="clearfix userCenterView enterpriseCertification">
        <div class="fr"><Bread :prop="bread" /></div>
        <div class="contentWrap fl"  style="width:100%">
            <div class="contentTitle">足迹</div>
            <div class="content" style="height:450px;">
                <BasicTable 
                hiddenFooter
                :tableData="tableData" 
                :columns="columns" 
                style="height:98%;margin:30px 0;"
                :pageSize="pageQuery.page_size"
                @pageChange="pageChange"
                :total="pageQuery.total">
                    <template v-slot:goods_name="{ item }">
                        <div><img :src="'https://api.goodyiyao.cn/' + item.original_img" style="width: 100px;" /></div>
                        <div>{{item.goods_name}}</div>
                    </template>
                    <template v-slot:visit_time="{ item }">
                        {{item.visit_time*1000 | dateFormat('YYYY-MM-DD') }}
                    </template>
                    <template v-slot:op="{ item }">
                        <router-link :to="{path:'/goodDetail/' + item.goods_id}">查看</router-link>
                    </template>
                </BasicTable>
                
            </div>
        </div>
    </div>
</template>

<script>
import Bread from '@/components/Bread/index'
import { UserCenterService } from '../../../service/userCenter.service'

const columns = [
  { name: '商品名称', key: 'goods_name',type: 'custom' },
  { name: '浏览时间', key: 'visit_time',type: 'custom'},
  { name: '操作', key: 'op',type: 'custom' },
];

export default {
    components:{ Bread },
    data() {
        return {
            bread: [{
                name: '用户中心',
                path: '/userCenter/index'
            },{
                name: '足迹',
                path: '/userCenter/score'
            }],
            tableData:[],
            columns,
            pageQuery:{
                page: 1,
                total: 0,
                page_size:2
            }
        }
    },
    methods: {
        async getList() {
            const data = await UserCenterService.browsingHistory(this.pageQuery)
            this.tableData = JSON.parse(JSON.stringify(data.list))
            this.tableData.forEach(val=>{
                val.original_img = UserCenterService.thumbImg(val.original_img)
            })
            this.pageQuery.total = data.totalRow
        },
        async pageChange(index) {
            this.pageQuery.page = index
            const data = await UserCenterService.messageList(this.pageQuery);
            this.tableData = JSON.parse(JSON.stringify(data.list))
        },
    },
    created() {
        this.getList()
    }
    
}
</script>
<style lang="scss" scoped>
    .userCenterView{
        width: 935px;
        .content{
            padding: 40px 30px 50px 30px;
            border: 1px solid #e3e2e1;
            display: block;
            .scoreTitle{
                font-size: 16px;
                font-weight: 700;
            }
        }
    }
</style>